/**
 * pages/PortalLayout.tsx — CLI-450
 * Оболочка кабинета пациента. Мобайл-first: нижняя навигация.
 * Авторизация: если нет токена — редирект на /login.
 */
import { Navigate, Outlet, NavLink } from 'react-router-dom';
import { useAuthStore } from '../store/auth.store';
import { logout } from '../services/patient.service';

function NavIcon({ children }: { children: React.ReactNode }) {
  return <span className="text-xl">{children}</span>;
}

export function PortalLayout() {
  const { patient } = useAuthStore();

  if (!patient) return <Navigate to="/login" replace />;

  async function handleLogout() {
    await logout();
    // Zustand store обнуляется → <Navigate to="/login"> выполнится при следующем рендере
  }

  const navItems = [
    { to: '/portal',               label: 'Главная',      icon: '🏠', end: true },
    { to: '/portal/documents',     label: 'Документы',    icon: '📄' },
    { to: '/portal/lab',           label: 'Анализы',      icon: '🧪' },
    { to: '/portal/studies',       label: 'Исследования', icon: '🩻' },
    { to: '/portal/appointments',  label: 'Мои записи',   icon: '📅' },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <header className="bg-primary-700 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-10 shadow">
        <div>
          <h1 className="text-base font-semibold leading-tight">Мой кабинет</h1>
          <p className="text-xs text-primary-200">
            {patient.lastName} {patient.firstName}
          </p>
        </div>
        <button
          onClick={() => { void handleLogout(); }}
          className="text-xs text-primary-200 hover:text-white transition px-2 py-1 rounded"
          aria-label="Выйти"
        >
          Выйти
        </button>
      </header>

      {/* Content */}
      <main className="flex-1 overflow-y-auto pb-20">
        <Outlet />
      </main>

      {/* Bottom navigation (mobile-first) */}
      <nav className="fixed bottom-0 inset-x-0 bg-white border-t border-gray-200 flex z-10">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            {...(item.end === true ? { end: true } : {})}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center py-2 text-xs transition ${
                isActive ? 'text-primary-700 font-semibold' : 'text-gray-500'
              }`
            }
          >
            <NavIcon>{item.icon}</NavIcon>
            <span className="mt-0.5 leading-none">{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </div>
  );
}
